<template>
  <div :class="'md-layout-item md-small-size-100'">
    <md-card>
      <md-card-content>
        <div :class="'md-layout-item md-small-size-100'">
          <div :class="'md-layout'">
            <div :class="'md-layout-item'">
              <md-field>
                <label>Name</label>
                <md-input v-model="questionnaire.name" disabled type="text" maxlength="254">
                </md-input>
              </md-field>
            </div>
          </div>
          <div :class="'md-layout'">
            <div :class="'md-layout-item'">
              <label :class="'md-layout-item md-size-15 md-form-label'">
                RQR Type:
              </label>
              <md-radio v-for="(value, code) in listOfRqrType()" :key="code" v-model="questionnaire.rqr_type" :value="value.code">
                {{ value.label }}
              </md-radio>
            </div>
          </div>
          <div :class="'md-layout'" v-for="(section, i) in sections" :key="i">
            <div :class="'md-layout-item'">
              <h6>{{ i + 1 }}. {{ section.section_text }} {{ section.section_description ? `- ${section.section_description}` : '' }}</h6>
              <md-checkbox
                v-for="(question, i) in section.questions" :key="i"  v-model="selected" :value="question.id">
                  {{ question.text }}
              </md-checkbox>
            </div>
          </div>
        </div>
      </md-card-content>
      <md-card-actions md-alignment="left">
        <md-button :class="'md-default'" @click.prevent="$emit('close')">
          Back
        </md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { rqrTypesMap } from "@/filters/rqrType"

  export default {
    data () {
      return {
        selected: []
      }
    },

    computed: {
      sections () {
        return this.getSections()
      }
    },

    methods: {
      getSections () {
        return _(this.questionnaire.questions)
          .sortBy('question_order')
          .sortBy('section_order')
          .groupBy(x => x.section)
          .map(value => {
            value.forEach(v => this.selected.push(v.id))
            return {
              section_text: value[0].section_text,
              section_description: value[0].section_description,
              questions: value
            }
          })
          .value()
      },

      listOfRqrType(){
        const rqrTypeArray = [];
        Object.entries(rqrTypesMap).forEach(([key, value]) =>
          rqrTypeArray.push({label: value, code: Number(key)})
        )
        return rqrTypeArray;      
      },
    },

    props: {
      questionnaire: {
        type: Object,
        default: () => {}
      }
    },
  }
</script>